import { Box } from '@chakra-ui/react'
import { AppContext } from '@hb/react'
import { useContext } from 'react'
import { useProfile } from '../../../../../../contexts/user/ProfileContext'
import { useUpdateDoc } from '../../../../../../hooks/backend/useUpdateDoc'
import { NoteForm } from '../../../../../forms/NoteForm'

export const PatientNotes = () => {
  const { user, adminPatientRef, practicePatientRef } = useProfile()
  const { patientNote } = user ?? {}

  const { appName } = useContext(AppContext)
  const update = useUpdateDoc('patient')

  return (
    <Box w="100%" p={1}>
      <NoteForm
        note={patientNote}
        boxProps={{ background: 'transparent', boxShadow: 'none', p: 0 }}
        placeholder="Patient notes"
        onSubmit={data =>
          update(appName === 'app' ? adminPatientRef : practicePatientRef, 'patientNote', data)
        }
      />
    </Box>
  )
}
